export const spacing = {
    sp6: 6,
    sp2: 2
}